export const cleanUpString = (string) => {
  return string
    .replaceAll('\'', '’')
    .replaceAll(/(<([^>]+)>)/gi, '')
    .replaceAll(/[\r\n]/g, '')
}
